"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/RightSide/Header/HeaderItemsDivider.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

const HeaderItemsDivider = () => (
  _react2.default.createElement('div', { className: "blmh-mobile right-side-header--item--divider" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 4}} )
)

exports. default = HeaderItemsDivider
